export const accordion = {
  mounted: (node: HTMLElement, params): any => {
    const triggers = node.querySelectorAll<HTMLElement>('.js-accordion-trigger')
    const items = [...node.querySelectorAll<HTMLElement>('.js-accordion-item')]

    const scrolly = (id: string) => {
      setTimeout(() => {
        const item = items.find((el) => el.dataset.id === id)
        const itemTrigger = [...triggers].find((el) => el.dataset.id === id)

        items.forEach((elem: HTMLElement, ind) => {
          if (id !== elem.dataset.id) {
            elem.classList.remove('is-open')
          }
        })
        triggers.forEach((elem: HTMLElement, ind) => {
          if (id !== elem.dataset.id) {
            elem.classList.remove('is-open')
          }
        })

        if (!item) return

        item.classList.add('is-open')
        itemTrigger.classList.add('is-open')
        const offset = item.getBoundingClientRect().top + window.pageYOffset

        window.scrollTo({ top: offset, behavior: 'smooth' })

      }, 1200)
    }

    const checkUrl = () => {
      const { hash } = window.location

      if (hash) {
        const preparedHash = hash.replace('#', '')

        scrolly(preparedHash)
      }
    }

    const addHashHandler = (el) => {
      const hash = el.dataset.id

      const newPath = `${window.location.pathname}#${hash}`

      window.history.replaceState(null, null, newPath)
    }

    if (params.value?.saveHash) {
      checkUrl()
    }

    triggers.forEach((el: HTMLElement, index) => {
      el.addEventListener('click', () => {
        if (el.closest('.js-accordion-item')) {
          triggers.forEach((elem: HTMLElement, ind) => {
            if (index !== ind) {
              elem.closest('.js-accordion-item')?.classList.remove('is-open')
            }
          })
        } else {
          [...triggers].forEach((elem: HTMLElement, ind) => {
            if (el.dataset.id !== elem.dataset.id) {
              elem.classList.remove('is-open')
            }
          });
          [...items].forEach((elem: HTMLElement, ind) => {
            if (el.dataset.id !== elem.dataset.id) {
              elem.classList.remove('is-open')
            }
          })

        }

        const elWrapper =
          el.closest('.js-accordion-item') ||
          [...items].find((elem) => {
            return elem.dataset.id === el.dataset.id
          })

          
          
        if (params.value?.dissallowClose) {
          el?.classList.add('is-open')
          elWrapper?.classList.add('is-open')
        } else {
          el?.classList.toggle('is-open')
          elWrapper?.classList.toggle('is-open')
        }

        if (params.value?.saveHash) {
          addHashHandler(elWrapper)
        }
      })
    })
  },
}
